export default "__VITE_ASSET__qpDUzEwn__"